import { AnyAction } from 'redux';
import {
    RESET_STATE,
    GET_ALL_APP_LIBRARY,
    GET_ALL_APP_LIBRARY_LOADING,
    SET_APP_LIBRARY_COUNT,
    GET_APP,
    ADD_APP_FINISHED,
    SET_APPLICATION_CERTIFICATE,
    GET_GROUPS_APP_DETAIL
} from '@app/store/constants';

const initialState = {
    app: {},
    apps: [],
    count: 0,
    appsLoading: false,
    groupAppDetail: null,
    addAppFinished: {
        finished: false,
        appId: ''
    },
    appCertificate: {}
};

export function appLibrary(state = initialState, action: AnyAction) {
    const { payload, type } = action;

    switch (type) {
        case RESET_STATE:
            return initialState;

        case GET_APP:
            return {
                ...state,
                app: payload
            };

        case GET_ALL_APP_LIBRARY:
            return {
                ...state,
                apps: payload
            };
        case GET_GROUPS_APP_DETAIL:
            return {
                ...state,
                groupAppDetail: payload
            };
        case GET_ALL_APP_LIBRARY_LOADING:
            return {
                ...state,
                appsLoading: payload
            };

        case SET_APP_LIBRARY_COUNT:
            return {
                ...state,
                count: payload
            };

        case ADD_APP_FINISHED:
            return {
                ...state,
                addAppFinished: payload
            };

        case SET_APPLICATION_CERTIFICATE:
            return {
                ...state,
                appCertificate: payload
            };

        default:
            return state;
    }
}
